export class AuthenticationConstants {
  static readonly tokenKey = "ping_access_token";
  static readonly codeKey = "code";
  static readonly redirectRoute = "auth/callback";
}
